import {
  action,
  computed,
  flow,
  flowResult,
  makeObservable,
  observable,
} from "mobx";
import { fetchCollections, fetchHavePass } from "../../api/ApiManager";
import { ICollection } from "../../entities/Collection/CollectionTypes";
import CollectionOptionsStore from "../../pages/MainPage/CollectionOptionsStore";
import BusyStore from "../../stores/common/BusyStore";

class PlaceARaffleStore extends BusyStore {
  collectionServiceMap: Map<string, CollectionOptionsStore> = new Map();
  isListingTypeModalVisible: boolean = false;
  havePass: boolean = false;

  constructor() {
    super();
    makeObservable<PlaceARaffleStore, "loadCollectionItemsFlow">(this, {
      collectionServiceMap: observable,
      isListingTypeModalVisible: observable,
      havePass: observable,

      collectionServices: computed,

      fetchHavePassFlow: action,
      setListingTypeModalVisibility: action,

      loadCollectionItemsFlow: flow,
    });
  }

  get collectionServices(): CollectionOptionsStore[] {
    return [...this.collectionServiceMap.values()];
  }

  setListingTypeModalVisibility = (isVisible: boolean): void => {
    this.isListingTypeModalVisible = isVisible;
  };

  async fetchHavePassFlow(address: string) {
    const response = await fetchHavePass(address);
    if (response?.length) {
      this.havePass = true;
    } else {
      this.havePass = false;
    }
  }

  loadCollectionItems(): Promise<void> {
    return flowResult(this.loadCollectionItemsFlow());
  }

  private *loadCollectionItemsFlow() {
    this.onLoadingStart();
    try {
      const collectionItems: ICollection[] = yield fetchCollections();
      const collectionServiceMapTemp = new Map<
        string,
        CollectionOptionsStore
      >();
      collectionItems.forEach((item) => {
        collectionServiceMapTemp.set(
          item.address,
          new CollectionOptionsStore(item)
        );
      });
      this.collectionServiceMap = collectionServiceMapTemp;
    } finally {
      this.onLoadingFinished();
    }
  }
}

export default PlaceARaffleStore;
